import * as endpoints from '@App/constants/endpoints';
import interceptor from '../interceptor';

const PLAN = 'plan';

const _get = async props => {
    const { axios, pathUrl } = props;
    try {
        return (await axios.get(pathUrl)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback,
            };
        throw error;
    }
};

const _post = async (axios, pathUrl, params = {}) => {
    try {
        return (await axios.post(pathUrl, params)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback,
                ...error.response.data
            };
        throw error;
    }
};

const _put = async (axios, pathUrl, params = {}) => {
    try {
        return (await axios.put(pathUrl, params)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback,
            };
        throw error;
    }
};

const _patch = async (axios, pathUrl, params = {}) => {
    try {
        return (await axios.patch(pathUrl, params)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback,
            };
        throw error;
    }
};

const _delete = async (axios, pathUrl) => {
    try {
        return (await axios.delete(pathUrl)).data;
    } catch (error) {
        if (error && error.response && error.response.status)
            throw {
                status: error.response.status,
                userFeedback: error.response.data.userFeedback,
            };
        throw error;
    }
};

export const getPlans = async ({ active, header } = {}) => {
    const queryStr = active !== undefined ? `?active=${active}` : '';
    const pathUrl = `${endpoints.API_ACCOUNT}/${PLAN}${queryStr}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl });
};

export const getPlanById = async ({ planId, header }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${PLAN}/${planId}`;
    const axios = interceptor(header);
    return await _get({ axios, pathUrl });
};

export const createPlan = async (params) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${PLAN}`;
    const axios = interceptor();
    return await _post(axios, pathUrl, params);
};

export const updatePlan = async ({ planId, params }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${PLAN}/${planId}`;
    const axios = interceptor();
    return await _put(axios, pathUrl, params);
};

export const togglePlan = async ({ planId, active }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${PLAN}/${planId}/toggle`;
    const axios = interceptor();
    return await _patch(axios, pathUrl, { active });
};

export const deletePlan = async ({ planId }) => {
    const pathUrl = `${endpoints.API_ACCOUNT}/${PLAN}/${planId}`;
    const axios = interceptor();
    return await _delete(axios, pathUrl);
};
